import { updateNotificationsRequest } from 'modules/notificationCenter/actions';
import { ModernizedNotificationCard } from 'modules/notificationCenter/components/NotificationCard';
import { NotificationEmptyState } from 'modules/notificationCenter/components/NotificationEmptyState';
import { notificationCenterSelector } from 'modules/notificationCenter/selectors';
import { NotificationItem, NotificationStatus } from 'modules/notificationCenter/types';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { NotificationsLoading } from './NotificationsLoading';

const { READ, UNREAD } = NotificationStatus;

const Wrapper = styled.div`
  min-height: 100%;
  max-height: 100%;
  overflow: auto;
  padding: ${spacing.plusHalf};
  background-color: ${colors.backgroundSecondary};
`;

const NotificationsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  margin: 0;
  padding: 0;
  list-style: none;
`;

const EmptyStateWrapper = styled(Wrapper)`
  padding: ${spacing.x7} ${spacing.plusHalf} ${spacing.plusHalf};
`;

export const Notifications = () => {
  const dispatch = useDispatch();
  const { isLoading, notifications } = useSelector(notificationCenterSelector);

  const handleUpdateNotification = ({ notification: { id }, status }: NotificationItem) => {
    const oppositeStatus = status === READ ? UNREAD : READ;
    dispatch(updateNotificationsRequest([{ notificationId: id, status: oppositeStatus }]));
  };

  if (isLoading) {
    return (
      <Wrapper>
        <NotificationsLoading />
      </Wrapper>
    );
  }

  if (notifications.length === 0) {
    return (
      <EmptyStateWrapper>
        <NotificationEmptyState />
      </EmptyStateWrapper>
    );
  }

  return (
    <Wrapper>
      <NotificationsList>
        {notifications?.map((notification) => {
          return (
            <ModernizedNotificationCard
              key={notification.notification.id}
              notification={notification.notification}
              status={notification.status}
              updateNotifications={() => handleUpdateNotification(notification)}
            />
          );
        })}
      </NotificationsList>
    </Wrapper>
  );
};
